import classNames from 'classnames';
import { IconX } from 'featherico';
import * as PropTypes from 'prop-types';
import type * as React from 'react';
import Button from '../Button';
import styles from './style.m.less';

export const COLOURS = {
    BLUE: [styles.blue],
    GREEN: [styles.green],
    NEUTRAL: [styles.neutral],
    RED: [styles.red],
    YELLOW: [styles.yellow],
    WHITE: [styles.white],
    PURPLE: [styles.purple],
};

export const CALLOUT_POSITIONS = {
    BOTTOM: 'callout--bottom',
    BOTTOM_LEFT: 'callout--bottom--left',
    BOTTOM_RIGHT: 'callout--bottom--right',
    LEFT: 'callout--left',
    LEFT_TOP: 'callout--left--top',
    LEFT_BOTTOM: 'callout--left--bottom',
    RIGHT: 'callout--right',
    RIGHT_TOP: 'callout--right--top',
    RIGHT_BOTTOM: 'callout--right--bottom',
    TOP: 'callout--top',
    TOP_LEFT: 'callout--top--left',
    TOP_RIGHT: 'callout--top--right',
};

export interface Props {
    colour: keyof typeof COLOURS;
    compact?: boolean;
    children?: React.ReactNode;
    onDismiss?(): void;
    className?: string;
    title?: React.ReactNode;
    calloutPosition?: keyof typeof CALLOUT_POSITIONS;
    smallFont?: boolean;
}

function AlertBox({ colour, compact, onDismiss, className, title, calloutPosition, children, smallFont }: Props) {
    const classes = classNames(
        className,
        calloutPosition ? [CALLOUT_POSITIONS[calloutPosition], styles.callout] : null,
        [styles.container],
        COLOURS[colour],
        compact ? styles.compact : null,
        smallFont ? styles.smallFont : null
    );

    return (
        <div className={classes}>
            <div className={styles.content}>
                {title && <div className={classNames(styles.title, children ? styles.titleMargin : null)}>{title}</div>}
                {children}
            </div>
            {onDismiss ? <DismissButton onClick={onDismiss} /> : null}
        </div>
    );
}

function DismissButton({ onClick }: { onClick?(): void }) {
    return (
        <Button kind="PLAIN" className={styles.controls} onClick={onClick}>
            <IconX />
        </Button>
    );
}

(AlertBox as any).propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    colour: PropTypes.oneOf(Object.keys(COLOURS)),
    onDismiss: PropTypes.func,
    calloutPosition: PropTypes.oneOf(Object.keys(CALLOUT_POSITIONS)),
};

export default AlertBox;
